var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFavUnselected = function SvgFavUnselected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.223 11.111a8 8 0 0 1 8 8v47.863a1 1 0 0 1-1.573.82L40.571 53.812a1 1 0 0 0-1.142 0l-20.08 13.984a1 1 0 0 1-1.572-.821V19.11a8 8 0 0 1 8-8h28.446ZM45.065 22.5c-2.166 0-4.038 1.21-5.076 2.986-1.037-1.775-2.91-2.986-5.076-2.986-2.504-.012-4.748 1.614-5.583 4.023v.012c-2.47 7.666 9.732 14.572 10.264 14.862a.853.853 0 0 0 .812 0c.52-.289 12.735-7.195 10.265-14.862l-.023.012v-.012c-.834-2.41-3.08-4.035-5.584-4.035Z",
    fill: "url(#fav-unselected_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fav-unselected_svg__a",
    x1: 40,
    y1: 11.111,
    x2: 40,
    y2: 67.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.7
  })))));
};
export default SvgFavUnselected;